import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PortalSettingsService } from '../../core/services/portal-settings.service';
import { EventService } from 'src/app/core/services/event.service';
import { HomeService } from '../../pages/home/services/home.service';
import { UtilityService } from '../../core/services/utility.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-onboarding-layout',
  templateUrl: './onboarding-layout.component.html',
  styleUrls: ['./onboarding-layout.component.css'],
})
export class OnboardingLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('logout') logoutNav: ElementRef<HTMLAnchorElement>;
  portalSettings: any;
  isSafari = false;
  isMobileIos: any;
  showLogout = false;
  showAT = false;
  showON = false;
  oNLogoCo: number;
  portalName: string;
  logoUrl: string;
  isExternalJobsiteBrowseJobs = false;
  private subscriptions: Subscription[] = [];

  constructor(
    portalSettingsService: PortalSettingsService,
    private homeService: HomeService,
    private eventService: EventService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.oNLogoCo = this.portalSettings.OnboardingLogoCo.ConfigValue;
    this.isSafari = this.utilityService.checkSafari();
    this.isMobileIos = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 7_|OS 8_|OS 9_|OS 10_|OS 11_|OS 12_\d)/i);
    if (this.isMobileIos != null && this.isSafari) {
      $('#NavBar').addClass('mobileSafari');
    }
    this.logoUrl = '/Company/GetLogo?co=' + this.oNLogoCo + '&size=S';
    var locationPathName = window.location.pathname.toLowerCase();
    if (locationPathName.indexOf('welcome') == -1) {
      this.showLogout = true;
    }
    if (locationPathName.indexOf('browsejobs') > 0 || locationPathName.indexOf('jobdetails') > 0) {
      this.isExternalJobsiteBrowseJobs = true;
    }
    this.subscriptions.push(this.eventService.on('ISAT', () => this.ISAT()));
    this.subscriptions.push(this.eventService.on('ISON', () => this.ISON()));
    this.getPortalName();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }

  private ISAT() {
    this.showAT = true;
    setTimeout(() => {
      this.logoutNav.nativeElement.addEventListener('click', event => {
        event.preventDefault();
        this.utilityService.isLoggedOut = true;
        window.location.href = this.logoutNav.nativeElement.href;
      });
    });
    this.showON = false;
  }

  private ISON() {
    this.showAT = false;
    this.showON = true;
  }

  getPortalName() {
    this.homeService.getPortalName(this.oNLogoCo).then(response => {
      this.portalName = response == '' ? null : response;
    });
  }
}
